import * as React from 'react';
import ObjectPurposeApiService from '../../../api/ObjectPurposeApiService';
import Routes from '../../../config/Routes';
import FeatureFlag from '../../../consts/FeatureFlag';
import ObjectPurposeDataTableDTO from '../../../models/ObjectPurposeDataTableDTO';
import TableRequestDTO from '../../../models/TableRequestDTO';
import BaseDataTableState from '../../../redux/bases/BaseDataTableState';
import BaseFormProps from '../../../redux/bases/BaseFormProps';
import BaseFormState from '../../../redux/bases/BaseFormState';
import AuthorizationUtil from '../../../utils/AuthorizationUtil';
import DateTimeUtil from '../../../utils/DateTimeUtil';
import FileDownload from '../../../utils/FileDownload';
import HistoryUtil from '../../../utils/HistoryUtil';
import DataTable, { DataTableColumnProps, FilterType } from '../core/DataTable';
import DataTableButtonUtil from '../core/DataTableButtonUtil';

interface ObjectPurposeDataTableProps extends BaseFormProps {
}

interface ObjectPurposeDataTableState extends BaseDataTableState<ObjectPurposeDataTableDTO>, BaseFormState {
}

class ObjectPurposeDataTable extends React.Component<ObjectPurposeDataTableProps, ObjectPurposeDataTableState> {
  private _dataTable: DataTable<ObjectPurposeDataTableDTO> | undefined;

  constructor(props: ObjectPurposeDataTableProps) {
    super(props);
    this.state = {
    };

  }

  private getColumnDefinitions = () => {
    return [
      {
        title: 'Code',
        dataIndex: ObjectPurposeDataTableDTO.code,
        sorter: true,
        filterType: FilterType.Text,
        width: 125
      },
      {
        title: 'Name',
        dataIndex: ObjectPurposeDataTableDTO.name,
        sorter: true,
        filterType: FilterType.Text
      }
    ] as DataTableColumnProps<any>[];
  };

  private openObjectPurpose = (record: ObjectPurposeDataTableDTO) => {
    if (record.id) {
      HistoryUtil.push(Routes.generate(Routes.OBJECT_PURPOSE_DETAILS, { id: record.id }, {}));
    }
  }

  private addObjectPurpose = () => {
    HistoryUtil.push(Routes.generate(Routes.NEW_OBJECT_PURPOSE));
  }

  render() {
    const actionButtons = [];

    actionButtons.push(DataTableButtonUtil.Reset());
    actionButtons.push(
      DataTableButtonUtil.Export(
        (tableRequest: TableRequestDTO) => {
          this.setState({ exporting: true });
          return ObjectPurposeApiService.getObjectPurposeDataTableExport(tableRequest).then(file => {
            this.setState({ exporting: false });
            FileDownload.downloadBase64StringAsFile(`Object_Purpose_${DateTimeUtil.getDateStamp()}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', file ?? undefined);
          });
        },
        this.state.exporting
      )
    );
    if (AuthorizationUtil.isAuthorized([FeatureFlag.EDIT_OBJECT_PURPOSE])) {
      actionButtons.push(DataTableButtonUtil.Default('New Object Purpose', () => this.addObjectPurpose()));
    }

    return (
      <>
        <DataTable
          ref={(element: any) => (this._dataTable = element)}
          onRowClick={this.openObjectPurpose}
          serverSide={true}
          tableProps={{
            rowKey: 'id',
            scroll: { x: 500 }
          }}
          globalSearch={true}
          buttonBar={actionButtons}
          columns={this.getColumnDefinitions()}
          fetchData={{
            fetch: (requestState: TableRequestDTO) => ObjectPurposeApiService.getObjectPurposeTableData(requestState)
          }}
          stateSaving={{ enabled: true, tableUniqueKey: 'object_purpose_list' }} />
      </>
    );
  }
}

export default ObjectPurposeDataTable;
